// @ts-ignore
/* eslint-disable */
import { request } from '@/services/transit.request';

/** Lấy danh sách tất cả tỉnh/thành phố GET /api/v1/administrative-units/provinces */
export async function getAllProvinces(options?: { [key: string]: any }) {
  return request<API.AdministrativeUnitProvinceV2[]>(
    '/api/v1/administrative-units/provinces',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** Lấy danh sách tất cả phường/xã GET /api/v1/administrative-units/wards */
export async function getAllWards(options?: { [key: string]: any }) {
  return request<API.AdministrativeUnitWardV2[]>(
    '/api/v1/administrative-units/wards',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}
